import React, { useState } from 'react';
import HomePage from './pages/HomePage';
import StudioPage from './pages/StudioPage';

export default function App() {
  const [page, setPage] = useState('home');

  return (
    <div style={{ height: '100%' }}>
      {page === 'home' ? (
        <HomePage onCreate={() => setPage('studio')} />
      ) : (
        <StudioPage onBack={() => setPage('home')} />
      )}
    </div>
  );
}
